import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useStates() {
  const navigate = useNavigate();

  const [states, setStates] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStates = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/city-catalog/states', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setStates(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchStates();
  }, [fetchStates]);

  return { states, isLoading, error, refetch: fetchStates };
}
